import React from "react"
import styled from "@emotion/styled"
import { breakpoints, color, wrapper } from "../../utils/style"
import { graphql, Link, StaticQuery } from "gatsby"
import ButtonLink from "../shared/ButtonLink"
import FooterTheEntrance from "../Menus/FooterTheEntrance"
import FooterPlayViaMobile from "../Menus/FooterPlayViaMobile"
import FooterMenuDownloads from "../Menus/FooterMenuDownloads"
import FooterPlayOnline from "../Menus/FooterPlayOnline"
import LogoUpd from "./LogoSvg"
import Img from "gatsby-image"
import GetWindowWidth from "../shared/GetWindowWidth"
import RespondioChat from "./RespondioChat";

//import Logo from './Logo';

const FooterBlock = styled("footer")`
  background: radial-gradient(
    90.93% 16.58% at 49.62% 0%,
    #950c0c 0%,
    #260e0e 100%,
    #150303 100%
  );
  .top-footer-col {
    display: inline-block;
    vertical-align: top;
  }
  .top-footer-left {
    width: 30%;
    padding-right: 30px;
  }
  .top-footer-right {
    width: 70%;
    text-align: center;
    padding-top: 14px;
    ul {
      opacity: 0.6;
    }
  }
  .menu-col {
    display: inline-block;
    vertical-align: top;
    width: 30%;
    padding: 0 10px 20px;
    text-align: left;
  }
  .menu-col-wide {
    width: 40%;
    padding: 0 10px 0 20px;
    ul {
      column-count: 2;
      column-gap: 2px;
    }
  }
  ul {
    margin: 20px 0;
    list-style: none;
    li {
      font-size: 14px;
      margin: 0 15px 10px 0;
    }
    a {
      color: ${color.white};
    }
    a:hover,
    a:active,
    .active {
      color: ${color.yellow};
      text-decoration: none;
    }
  }
  .h4 {
    font-size: 18px;
    color: ${color.gold};
    margin-bottom: 20px;
    text-transform: uppercase;
    font-weight: 500;
  }
  .logo {
    display: inline-block;
  }
  .footer-top {
    padding: 20px 0;
  }
  .social-buttons {
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
      display: inline-block;
      margin-left: 5px;
      &:hover,
      &:active {
        svg {
          filter: drop-shadow(1px 1px 4px ${color.peach});
        }
      }
    }
  }
  .footer-bottom-copyright {
    margin-bottom: 50px;
  }
  .footer-brands {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .footer-brands .gatsby-image-wrapper {
    margin-right: 25px;
    height: 30px;
    img {
      filter: opacity(0.5);
    }
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(1) {
    width: 105px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(2) {
    width: 40px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(3) {
    width: 105px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(4) {
    width: 40px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(5) {
    width: 55px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(6) {
    width: 30px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(7) {
    width: 22px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(8) {
    width: 30px;
  }
  .footer-brands .gatsby-image-wrapper:nth-of-type(9) {
    width: 30px;
  }
  .footer-brands .gatsby-image-wrapper:last-child {
    margin-right: 0;
  }
  @media (max-width: ${breakpoints.lg}) {
    padding: 0 20px;

    .footer-bottom {
      max-width: 87%;
      margin: 0;
    }
    .social-buttons {
      padding: 0;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    padding-bottom: 50px;
    .footer-top {
      position: relative;
      padding-bottom: 10px;
      .footer-bottom {
        max-width: 100%;
        width: 100%;
      }
    }
    .top-footer-left {
      width: 100%;
      padding: 0;
    }
    .top-footer-right {
      padding-top: 15px;
    }
    .top-footer-left,
    .top-footer-right {
      width: 100%;
      text-align: left;
    }
    .menu-col:nth-of-type(odd) {
      padding-left: 2px;
    }
    .menu-col:nth-of-type(4) {
      padding-right: 0;
    }
    .footer-bottom-copyright {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .footer-top {
      .footer-bottom {
        padding: 10px;
      }
    }
    .social-buttons {
      padding: 0;
      text-align: center;
    }
    .menu-col {
      width: 100%;
    }
    .menu-col-wide {
      padding: 0 0 0 10px;
      ul {
        column-count: 1;
        column-gap: 0;
      }
    }
    .footer-brands {
      justify-content: space-between;
    }
    .footer-brands .gatsby-image-wrapper {
      margin-right: 10px;
      margin-bottom: 10px;
      display: inline-block;
    }
    .wrapper-mobile {
      padding: 0;
    }
  }
`

const Wrapper = styled("div")`
  ${wrapper}
  .logo {
    display: block;
  }
  .logo-wrapper {
    max-width: 118px;
    margin: 20px auto;
  }
`

const Copy = styled("div")`
  float: left;
  width: 31%;
  font-size: 14px;
  line-height: 1.2;
  text-align: left;
  padding-right: 20px;
  span {
    opacity: 0.4;
  }
  a {
    margin: 0 0 0 20px;
    color: ${color.white};
    text-decoration: underline;
  }
  @media (max-width: ${breakpoints.sm}) {
    padding-right: 0;
    float: none;
    width: 100%;
    margin-top: 20px;
  }
`

const FooterButtons = styled("div")`
  padding: 10px 0;
  .col {
    display: inline-block;
    vertical-align: top;
    width: 45%;
  }
  .col-right {
    width: 54%;
  }
  .line {
    padding: 3px 0 3px 15px;
  }
  .payment-span {
    display: inline-block;
    background: ${color.transparentWhite2};
    height: 50px;
    padding: 1px 0;
    border-radius: 5px;
    margin: 0 10px;
    vertical-align: middle;
  }
  .top-line {
    margin-bottom: 16px;
  }
  .button {
    display: block;
    margin-bottom: 20px;
    font-weight: 700;
    font-size: 1rem;
  }

  @media (max-width: ${breakpoints.lg}) {
    .col {
      width: 87%;
    }
    .line {
      display: flex;
      margin: 0 0 10px;
      padding: 0;
      justify-content: space-between;
    }
    .payment-span {
      flex: 0 0 48%;
      margin: 0;
      text-align: center;
    }
  }

  @media (max-width: ${breakpoints.md}) {
    .col {
      width: 100%;
    }
    .payment-span {
      flex: 0 0 49%;
      margin-bottom: 5px;
    }
    .button {
      margin-bottom: 15px;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    .col {
      width: 100%;
      text-align: center;
      margin-bottom: 20px;
    }
    .payment-span {
      flex: 0 0 48%;
    }
  }
`

export default () => (
  <StaticQuery
    query={graphql`
      query {
        allWordpressPage(filter: { slug: { eq: "home-page" } }) {
          edges {
            node {
              acf {
                footer_icons {
                  alt_text
                  title
                  path
                  acf {
                    slide_url
                    slide_title
                    slide_description
                  }
                  localFile {
                    childImageSharp {
                      fluid(maxWidth: 105) {
                        ...GatsbyImageSharpFluid_withWebp_noBase64
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const windowWidth = GetWindowWidth()
      const isDesktop = windowWidth > 600
      const footer_icons = data.allWordpressPage.edges[0].node.acf.footer_icons
      return (
        <FooterBlock>
          {/*<PopupWindow*/}
          {/*  title="Scan QR to talk"*/}
          {/*  popupId="line-popup-window"*/}
          {/*  extraClass="a-center"*/}
          {/*>*/}
          {/*  <LineQR to={process.env.LINE_ID} text="Line ID" />*/}
          {/*  <p>Add LINE Friends via QR Code</p>*/}
          {/*</PopupWindow>*/}
          <div className="footer-top">
            <Wrapper>
              <div className="top-footer-col top-footer-left">
                <LogoUpd to="/" text="royal-1688.net" />

                <FooterButtons className="footer-buttons">
                  <Link
                    className="button red-button"
                    to="/register/"
                    text="Register"
                  >
                    <span>สมัครสมาชิก</span>
                  </Link>
                  <ButtonLink
                    to={`tel:${process.env.PHONE_TO_CALL}`}
                    external={true}
                    ariaText="Call"
                    className="button transparent-button-gold"
                    text={process.env.PHONE_TO_DISPLAY}
                    iconName="call-answer"
                    iconColor={color.white}
                    iconLeft={true}
                    iconSize={18}
                  />
                  <ButtonLink
                    to={process.env.LINE_ID}
                    external={true}
                    iconColor={color.white}
                    ariaText="Line"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="button transparent-button-gold"
                    text={process.env.LINE_ID_TEXT}
                    iconName="line"
                    iconLeft={true}
                    iconSize={18}
                  />
                </FooterButtons>
              </div>
              <div className="top-footer-col top-footer-right">
                <div className="menu-col">
                  <div className="h4">ทางเข้า</div>
                  <FooterTheEntrance />
                  <div className="h4">เล่นผ่านมือถือ</div>
                  <FooterPlayViaMobile />
                </div>
                <div className="menu-col">
                  <div className="h4">เล่นผ่านเว็บ</div>
                  <FooterPlayOnline />
                </div>
                <div className="menu-col">
                  <div className="h4">ดาวน์โหลด</div>
                  <FooterMenuDownloads />
                </div>
              </div>
            </Wrapper>
          </div>
          <Wrapper className="wrapper-mobile">
            <div className="footer-bottom-copyright">
              <Copy>
                <span>All Rights Reserved © {process.env.FRONTEND_DOMAIN}</span>
                <Link to="/sitemap/">Sitemap</Link>
                <br />
                <span>The best casino games at the leading online casino.</span>
              </Copy>
              {isDesktop ? (
                <div className="footer-brands">
                  {footer_icons?.map(item => {
                    const localFile = item.localFile || {}
                    return (
                      <Img
                        key={item.path}
                        fluid={localFile?.childImageSharp?.fluid}
                        alt={item.alt_text ? item.alt_text : "footer icon"}
                        fadeIn={false}
                        loading="eager"
                      />
                    )
                  })}
                </div>
              ) : (
                <div className="footer-brands footer-brands-mobile">
                  {footer_icons?.map(item => {
                    const localFile = item.localFile || {}
                    return (
                      <Img
                        key={item.path}
                        fluid={localFile?.childImageSharp?.fluid}
                        alt={item.alt_text ? item.alt_text : "footer icon"}
                        fadeIn={false}
                        loading="eager"
                      />
                    )
                  })}
                </div>
              )}
            </div>
          </Wrapper>
          <RespondioChat />
        </FooterBlock>
      )
    }}
  />
)
